"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platformDisplayName = exports.DEFAULT_NOTIFICATION_PREFERENCES = exports.NotificationPreferencesSchema = void 0;
const v4_1 = require("zod/v4");
/** Company-level notification delivery preferences (defaults: all on). */
exports.NotificationPreferencesSchema = v4_1.z.object({
    postPublishFailedEmail: v4_1.z.boolean(),
    postPublishFailedInApp: v4_1.z.boolean(),
    postPublishSuccessInApp: v4_1.z.boolean(),
});
exports.DEFAULT_NOTIFICATION_PREFERENCES = {
    postPublishFailedEmail: true,
    postPublishFailedInApp: true,
    postPublishSuccessInApp: true,
};
const PLATFORM_DISPLAY_NAMES = {
    facebook: "Facebook",
    instagram: "Instagram",
    threads: "Threads",
    linkedin: "LinkedIn",
    tiktok: "TikTok",
    youtube: "YouTube",
    x: "X",
    wordpress: "WordPress",
    "custom-blog": "Custom blog",
    "google-business": "Google Business",
    google: "Google",
    canva: "Canva",
    "meta-ads": "Meta Ads",
    "tiktok-ads": "TikTok Ads",
};
const platformDisplayName = (platform) => { var _a; return (_a = PLATFORM_DISPLAY_NAMES[platform]) !== null && _a !== void 0 ? _a : platform; };
exports.platformDisplayName = platformDisplayName;
